import React from 'react'
import Home from '../Components/Home'
import Skills from './Skills'
import SkillsAccordion from '../Components/SkillsAccordian'
import Footer from '../Components/Footer'
import Education from '../Components/Education'


export default function MainPage() {
  return (
    <div  >
        <br />
        <br />
        <Home/>
        <br />
        <br />
        <br />
        <br />
        
<br />

<h2 style={{textAlign : 'center'}} >SKILLS</h2>



        <Skills/>

        <SkillsAccordion/>

        <br />
        <br />
        <br />
        <br />
        <br />
        

        <h2 style={{textAlign : 'center'}} > Internships / Work Experience  </h2>
        <br />

        <div className='internCardFlex'  >
           {/* <Internship1  />
           <Internship2/> */}

           <div className='internCards' >
             <p style={{fontWeight : '520'}} >Full Stack Developer Intern</p>
             <p>INEPT STUDIO</p>
             <p style={{fontSize : '15px' }} >Currently working as a Full Stack developer,<br />
               working on React.js , Node.js , Express.js , <br />
              Mysql technologies. </p>
           </div>

           <div className='internCards' >
             <p  style={{fontWeight : '520'}}>Full Stack Developer Trainee</p>
             <p>INEPT STUDIO</p>
             <p style={{fontSize : '15px' }} >Learnt the current demanding technologies <br />
                like React.js , Node.js , Express.js , Mysql.</p>
           </div>

        </div>

     
       
       <Education/>

       <br />
       <br />
       <br />
       
   <Footer/>

  
      
      <p style={{textAlign : 'center'}} >Developer : Sahil Rohera</p>
       


    </div>
  )
}
